import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ProductListSortSelect from './sort_select';
import ProductListPriceSelect from './price_select';
import ProductListSaleSelect from './sale_select';
import { SVGs } from '../../common/fa_icons';
import { injectIntl } from 'react-intl';
import i18nMessages from './__i18n__';
import RosettaFormattedMessage from '../../common/rosetta_formatted_message';
import MediaQuery from '../../common/media_query';
import classNames from 'classnames';

export class ProductListFilterSortWrapper extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { handleFilterAndSortUpdate,
      handleFilterAndSortClear, intl, handleFilterSaleClick,
      handleSort, handlePriceFilter, selectedPriceRange, on_sale,
      sort, filterSortHidden, handleFilterSortClick } = this.props;

    const messages = i18nMessages();

    return (
      <div>
        <div className={classNames('filter-sort-label', { 'active': !filterSortHidden })}>
          <span className="text"
            tabIndex="0"
            dangerouslySetInnerHTML={{ __html: intl.formatMessage(messages['Filter & Sort By']) }}
            onClick={handleFilterSortClick}
            onKeyPress={handleFilterSortClick}
          />
          <span className="fa fa-chevron-down"
            dangerouslySetInnerHTML={{ __html: SVGs['chevron-down'] }}
            onKeyPress={handleFilterSortClick}
          />
        </div>
        <div className={classNames('filter-sort-wrapper', { 'active': !filterSortHidden })}>
          <div className="dropdown">
            <div className={classNames({ 'hidden': filterSortHidden })} tabIndex="0">
              <MediaQuery breakpoint="notMobile">
                <span tabIndex="0" className="subnav-close-btn" onKeyPress={handleFilterSortClick} onClick={handleFilterSortClick} />
              </MediaQuery>
              <MediaQuery breakpoint="mobile">
                <div className="title sale" dangerouslySetInnerHTML={{ __html: intl.formatMessage(messages['Sort By']) }} />
                <ProductListSaleSelect on_sale={on_sale}
                  handleSaleToggle={handleFilterSaleClick}
                />
              </MediaQuery>
              <ProductListPriceSelect
                handlePriceFilter={handlePriceFilter}
                selectedPriceRange={selectedPriceRange}
              />
              <ProductListSortSelect
                handleSort={handleSort}
                sort={sort}
              />
              <div className="buttons" tabIndex="0">
                <button tabIndex="0" className="update-button" onClick={handleFilterAndSortUpdate} onKeyDown={handleFilterAndSortUpdate}>
                  <RosettaFormattedMessage parentFilename={__filename}
                    id="update_button"
                    description="Message for the product list page update button"
                    defaultMessage="update"
                  />
                </button>
                <button tabIndex="0" className="clear-button" onClick={handleFilterAndSortClear} onKeyPress={handleFilterAndSortClear}>
                  <RosettaFormattedMessage parentFilename={__filename}
                    id="clear_button"
                    description="Message for the product list page clear button"
                    defaultMessage="clear all"
                  />
                  <span className="fa fa-times"
                    dangerouslySetInnerHTML={{ __html: SVGs.times }}
                  />
                </button>
              </div>
            </div>
            {!filterSortHidden &&
              <MediaQuery breakpoint="mobile">
                <span className="subnav-close-btn" onClick={handleFilterSortClick} />
              </MediaQuery>
            }
          </div>
        </div>
      </div>
    );
  }

}

ProductListFilterSortWrapper.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  handleFilterAndSortUpdate: PropTypes.func.isRequired,
  handleFilterSortClick: PropTypes.func.isRequired,
  handleFilterAndSortClear: PropTypes.func.isRequired,
  handleFilterSaleClick: PropTypes.func,
  handleSort: PropTypes.func.isRequired,
  handlePriceFilter: PropTypes.func.isRequired,
  selectedPriceRange: PropTypes.object,
  on_sale: PropTypes.string,
  sort: PropTypes.string,
  filterSortHidden: PropTypes.bool.isRequired
};

export default injectIntl(ProductListFilterSortWrapper);
